module.exports = __webpack_public_path__ + "src/assets/img/spriteAnimalRaton.png";